import React, { useContext, useEffect, useState, useRef } from "react";
import { SimpleUtility } from "simple-ui-components";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { getTranslation } from "../languageProvider";
import UploadPDF from "../shared/uploadPDF";
import PDFDetail from "./PDFDetail";
import { get, post, del } from "../../server-requests/serverRequests";
import { AuthContext } from "../authContextProvider";
import { Log, ReplaceWord } from "../shared/utility";
import DeletePopup from "../shared/deletePopup";

const Documents = ({ currentRoute }) => {
  const { UpdateObject } = SimpleUtility;
  const deleteDocumentRef = useRef();

  const { snackbarHandler } = useContext(AuthContext);

  const [docs, setDocs] = useState({
    list: [],
    reload: true,
    clear: true,
  });

  const deletePDFClickHandler = (id) =>
    deleteDocumentRef.current.Delete(
      id,
      `${getTranslation("0032")} ${getTranslation("0171").toLowerCase()}`,
      ReplaceWord(
        getTranslation("0120"),
        "**NAME**",
        getTranslation("0171").toLowerCase()
      )
    );
  const deleteDocumentHandler = (id) => {
    del("routes/docs", { id, routeId: currentRoute.id })
      .then(() => {
        setDocs((prev) => UpdateObject(prev, { reload: true }));
        snackbarHandler(
          ReplaceWord(
            getTranslation("0121"),
            "**NAME**",
            getTranslation("0171")
          ),
          "success"
        );
      })
      .catch((status) => {
        snackbarHandler(getTranslation(`error${status}`));
        Log("Error on delete routes/docs" + status);
      });
  };

  useEffect(() => {
    let isMounted = true;
    if (currentRoute.id && docs.reload) {
      get("routes/docs/list", { routeId: currentRoute.id })
        .then((list) => {
          if (isMounted)
            setDocs((prev) => UpdateObject(prev, { list, reload: false }));
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
          setDocs((prev) => UpdateObject(prev, { reload: false }));
          Log("Error on get routes/docs/list" + status);
        });
    }
    return () => (isMounted = false);
  }, [currentRoute.id, docs.reload, UpdateObject, snackbarHandler]);

  const uploadPDFHandler = (event) => {
    if (event) {
      if (event.target.files.length > 0) {
        let file = event.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          let data = {
            content: reader.result.replace("data:application/pdf;base64,", ""),
            filename: file.name,
            routeId: currentRoute.id,
          };
          post("routes/docs", data)
            .then(() => {
              setDocs((prev) =>
                UpdateObject(prev, { reload: true, clear: !prev.clear })
              );
            })
            .catch((status) => {
              snackbarHandler(getTranslation(`error${status}`));
              setDocs((prev) => UpdateObject(prev, { clear: !prev.clear }));
            });
        };
      } else {
        setDocs((prev) => UpdateObject(prev, { clear: !prev.clear }));
      }
    } else {
      setDocs((prev) => UpdateObject(prev, { clear: !prev.clear }));
    }
  };

  let docListElement = null;
  if (docs.list.length > 0)
    docListElement = docs.list.map((item) => {
      return (
        <PDFDetail
          key={item.id}
          order={item}
          DeleteElement={
            <DeleteOutlineOutlinedIcon
              onClick={() => deletePDFClickHandler(item.id)}
              className="danger"
            />
          }
        />
      );
    });
  return (
    <>
      <UploadPDF
        labelName={getTranslation("0176")}
        Uploaded={uploadPDFHandler}
        accept=".pdf, .txt"
        clear={docs.clear}
      />
      {docListElement}
      <DeletePopup
        ref={deleteDocumentRef}
        DeleteSuccess={deleteDocumentHandler}
      />
    </>
  );
};

export default Documents;
